import React from 'react';
import HeaderComponent from '../../common/HeaderComponent/HeaderComponent';
import BottomAppBarComponent from '../../common/BottomAppBarComponent/BottomAppBarComponent';
import MyBooksComponents from '../MyBooksComponent/MyBooksComponent';
import FooterComponent from '../../common/FooterComponent/FooterComponent';



export default function GetBooksGalleryComponent() {
  return (
    <>
      <HeaderComponent />
      {/* <ComingSoonComponent component="Books"/> */}
      <MyBooksComponents />
      <FooterComponent />
      <BottomAppBarComponent />
    </>
  )
}
